const headerTheme = {
  boxToHoldEverything: {
    height: 65,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'rgba(240,240,240,0.5)',
    borderBottom: '1px solid grey',
  },

  boxToHoldLeftSide: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 5,
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },

  boxToHoldDashboardTitle: {
    fontSize: '18px',
  },

  boxToHoldDashboardSubtitle: {},

  boxToHoldRightSide: {
    width: '50%',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    backgroundColor: 'transparent',
    paddingRight: 10,
    gap: 10,
  },

  boxToHoldIcon: {
    width: 20,
    height: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0px 15px',
    cursor: 'pointer',
  },

  iconProperties: {
    width: 18,
    height: 20,
  },

  boxToHoldHeaderActions: {
    height: 65,
    backgroundColor: 'white',
  },
};

export default headerTheme;
